import { render, staticRenderFns } from "./DistrictReportPage.vue?vue&type=template&id=8a0f4fe8&scoped=true"
import script from "./DistrictReportPage.vue?vue&type=script&lang=js"
export * from "./DistrictReportPage.vue?vue&type=script&lang=js"
import style0 from "./DistrictReportPage.vue?vue&type=style&index=0&id=8a0f4fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0f4fe8",
  null
  
)

export default component.exports